import axios from "axios";

export const API_BASE = "https://sura-api.cloopapp.com";

export const api = axios.create({
  baseURL: API_BASE,
});

const TOKEN_KEY = "sura_token";

export const tokenStorage = {
  get: () => (typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null),
  set: (t: string) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

api.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && typeof window !== "undefined") {
      tokenStorage.clear();
      if (!window.location.pathname.match(/^\/(login|signup|$)/)) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);
